import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { storyblokEditable } from "@storyblok/react"
import { getSbLinkHref } from "@krakentech/blueprint-utils/storyblok"
import { type SbBlokImage } from "../types"
import { StoryblokImage } from "./StoryblokImage"

interface DynamicImageProps {
    blok: SbBlokImage
}

export function DynamicImage({ blok }: DynamicImageProps) {
    const href = blok.link && getSbLinkHref(blok.link)

    if (!blok?.image) {
        return (
            <StoryblokMissingField
                blok="Image"
                field="Image"
            />
        )
    }

    return (
        <div {...storyblokEditable(blok)}>
            <StoryblokImage
                src={blok.image.filename}
                tabletSrc={blok.tabletImage?.filename}
                mobileSrc={blok.mobileImage?.filename}
                alt={blok.alt || blok.image.alt || ""}
                href={href}
                target={blok.link?.target}
                width={blok.widthOverride ? parseInt(blok.widthOverride, 10) : undefined}
                height={blok.heightOverride ? parseInt(blok.heightOverride, 10) : undefined}
                caption={blok.caption}
                addLightModeBackground={blok.addLightModeBackground}
            />
        </div>
    )
}

export default DynamicImage
